// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__28AOs","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2XUwF","obliqueLine":"membershipbadge_obliqueLine__1jUN5"};